export default "__VITE_ASSET__$yVORWwQ__"